import {AccessType} from '../enmus/AccessType';

export default class AccessController {
    accessInfo = {};
    initAccess(accessInfo) {
        Object.values(AccessType).forEach(type => {
            this.accessInfo[type] = accessInfo[type] || [];
        });
    }

    /**
     * 查看是否有全选
     * @param {string} type 枚举AccessType
     */
    isAccess(type, sid) {
        const access = this.getAccessSids(type);
        return !!access.find(i => `${sid}` === `${i}`);
    }

    getAccessSids(type) {
        const access = this.accessInfo[type] || [];
        return access;
    }
}